import { Box, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useDeveloperContext } from "../hook/useDeveloperContext";

type Props = {
  title: string;
};

export const DeveloperHeader = ({ title }: Props) => {
  const navigate = useNavigate();
  const { handleUsername, handleSessionKey } = useDeveloperContext();

  const handleSignout = () => {
    handleUsername("");
    handleSessionKey("");

    navigate("/login");
  };

  return (
    <Box className="home-bg pt-8 pb-20">
      <Box className="container-xxl">
        <Box className="d-flex flex-wrap justify-content-between align-items-center gap-4">
          <Box>
            <Link className="small text-white opacity-75" to="/">
              <ArrowBackIosIcon className="small-icon" /> Back Home
            </Link>
            <Typography className="text-white my-1" variant="h5">
              {title}
            </Typography>
          </Box>
          <Box className="d-flex gap-3">
            <Link className="btn btn-light" to="#" onClick={handleSignout}>
              <ExitToAppIcon className="text-icon" /> Sign Out
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
